"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var g2_1 = require("@antv/g2");
var LineActive = /** @class */ (function (_super) {
    tslib_1.__extends(LineActive, _super);
    function LineActive(cfg) {
        return _super.call(this, tslib_1.__assign({ 
            /** 没有用 line:mouseenter 和 line:mouseleave 事件，是因为可能在多条折线的情况下，从一条线滑动到另一条会同时触发process和reset，使画面出现闪动 */
            processEvent: 'mousemove' }, cfg)) || this;
    }
    LineActive.prototype.process = function (ev) {
        var target = ev.target;
        if (target.name === 'line') {
            var data_1 = ev.data[0]._origin;
            this.view.setActive(function (obj) {
                return obj === data_1;
            });
        }
        else {
            this.view.setActive(function () {
                return false;
            });
        }
    };
    return LineActive;
}(g2_1.Interaction));
exports.default = LineActive;
//# sourceMappingURL=line-active.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/line/interaction/line-active.js
// module id = 928
// module chunks = 37